var render = function render(){var _vm=this,_c=_vm._self._c;return _c('servicos',{attrs:{"permitirAprovar":_vm.$temAcessoView('GESCON-GER-SERV-00'),"permitirReprovar":_vm.$temAcessoView('GESCON-GER-SERV-00'),"permiteDetalhar":_vm.$temAcessoView('GESCON-GER-SERV-00'),"rotaDetalhar":"Gescon_Gerentes_Servicos_Detalhar","rotaListagem":"Gescon_Gerentes_Servicos_Listagem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }